import {
  AnyAction,
  combineReducers,
  configureStore,
  Reducer,
} from '@reduxjs/toolkit';
import { RootState } from './hooks';
import { authSlice } from './helperServices/auth/auth.slice';
import { assessmentsSlice } from './reduxRepositories/assessments/assessments.slice';
import { usersSlice } from './reduxRepositories/users/users.slice';
import { incidentSlice } from './reduxRepositories/incident/incident.slice';
import { assessmentCreationViewSlice } from '../clinicApp/pages/assessment/assessmentCreationView/assessmentCreationView.slice';
import { playerProfilePageQuerySlice } from '../pages/playerProfile/playerProfilePage.queryParam.slice';
import { assessmentPageQuerySlice } from '../clinicApp/pages/assessment/assessment.queryParam.slice';
import { userPageQuerySlice } from '../pages/user/user.queryParam.slice';
import { incidentPageQuerySlice } from '../pages/createIncident/createIncident.queryParam.slice';
import { globalQuerySlice } from './queryParams/global.query.slice';
import { loginPageQuerySlice } from '../pages/login/login.queryParam.slice';
import { conneqtSlice } from './reduxRepositories/conneqt/conneqt.slice';
import { teamsSlice } from './reduxRepositories/teams/teams.slice';
import { incidentStepperQuerySlice } from '../pages/createIncident/incidentStepper.slice';
import { teamPageQuerySlice } from '../orgApp/pages/listTeams/listTeams.queryParam.slice';
import { playersSlice } from './reduxRepositories/players/players.slice';
import { notificationsSlice } from './reduxRepositories/notifications/notifications.slice';
import { accountsSlice } from './reduxRepositories/accounts/accounts.slice';
import { incidentCreationViewSlice } from '../pages/createIncident/viewServices/createIncident.view.slice';
import { incidentListPageQuerySlice } from '../pages/incidentsList/incidentList.queryParam.slice';
import { viewIncidentPageQuerySlice } from '../pages/viewIncident/viewIncident.queryParam.slice';
import { assessmentSummaryPageQuerySlice } from '../pages/assessmentSummary/assessmentSummary.queryParam.slice';
import { pageQuerySlice } from './queryParams/pageQueries.slice';
import { viewSlice } from './reduxViewServices/view.slice';
import { themeSlice } from '../components/toggleThemeSwitch/theme.slice';
import { takeAssessmentStepperSlice } from '../clinicApp/pages/assessment/takeAssessment/takeAssessmentStepper.slice';
import { stepperSlice } from '../components/stepper/stepper.slice';
import { downloadPlayerUploadTemplateSlice } from './reduxRepositories/downloadPlayerTemplate/downloadPlayerTemplate.slice';
import { regionSlice } from './reduxRepositories/region/region.slice';

const combinedReducer = combineReducers({
  // TODO: add an entityAdapter to each repository and use as default if not overridden by sending in a selectors and dispatchers. Make it automatic when you extend a new repository.
  // GLOBAL
  globalQuery: globalQuerySlice.reducer,
  // PAGE QUERIES
  pageQueries: pageQuerySlice.reducer,
  // VIEW SERVICES
  viewState: viewSlice.reducer,
  // AUTH
  loginPageQuery: loginPageQuerySlice.reducer,
  authReducer: authSlice.reducer,
  // USER
  userPageQuery: userPageQuerySlice.reducer,
  usersReducer: usersSlice.reducer,
  teamsReducer: teamsSlice.reducer,
  // PLAYER
  playerProfilePageQuery: playerProfilePageQuerySlice.reducer,
  playersReducer: playersSlice.reducer,

  notificationsReducer: notificationsSlice.reducer,
  teamPageQuery: teamPageQuerySlice.reducer,
  // INCIDENT REPORT
  incidentPageQuery: incidentPageQuerySlice.reducer,
  incidentReducer: incidentSlice.reducer,
  assessmentSummaryPageQuery: assessmentSummaryPageQuerySlice.reducer,
  incidentListPageQuery: incidentListPageQuerySlice.reducer,
  viewIncidentPageQuery: viewIncidentPageQuerySlice.reducer,
  incidentCreationViewReducer: incidentCreationViewSlice.reducer,
  // QUESTION: should this be using the shared stepper?
  incidentStepperQuery: incidentStepperQuerySlice.reducer,
  // CONNEQT
  conneqtReducer: conneqtSlice.reducer,
  // ASSESSMENT
  assessmentPageQuery: assessmentPageQuerySlice.reducer,
  assessmentsReducer: assessmentsSlice.reducer,
  assessmentCreationReducer: assessmentCreationViewSlice.reducer,
  takeAssessmentStepperReducer: takeAssessmentStepperSlice.reducer,
  // STEPPERS
  stepperReducer: stepperSlice.reducer,

  themeReducer: themeSlice.reducer,

  // ACCOUNTS
  accountsReducer: accountsSlice.reducer,

  regionReducer: regionSlice.reducer,
  downloadPlayerTemplateReducer: downloadPlayerUploadTemplateSlice.reducer,
});

export const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'RESET_STORE') {
    // eslint-disable-next-line no-param-reassign
    state = undefined;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  // middleware: [...getDefaultMiddleware()],
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    });
  },
});

export type AppDispatch = typeof store.dispatch;

export const dataStoreTypeNames = [
  { typeString: 'User', amplifyType: 'User' },
  { typeString: 'Assessment', amplifyType: 'Assessment' },
  { typeString: 'Incident', amplifyType: 'Incident' },
  { typeString: 'Player', amplifyType: 'Player' },
  { typeString: 'Notification', amplifyType: 'Notification' },
  { typeString: 'Conneqt', amplifyType: 'Conneqt' },
  { typeString: 'Team', amplifyType: 'Team' },
  { typeString: 'Account', amplifyType: 'Account' },
];
